import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";

import {
	Calculator3View
} from '../../components/pbm-calculator/';

class Calculator3 extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);
	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <Calculator3View />
					</Col>
				</Row>
			</div>
		);
	}
}

export default Calculator3;
